<div class="cmn-input-field">
  @if (label) {
  <label class="cmn-input-field__label" [for]="id">
    {{ label }}
    @if (required) {
    <span class="required-field">*</span>
    }
  </label>
  }

  <div class="cmnh-input-wrap cmnh-input__status-wrapper" [class.cmnh-input--error]="hasError">
    @if (searchIcon) {
    @if (loading) {
    <span class="cmnh-input__icon cmnh-input__icon--left" aria-hidden="true">
      <span class="cmnh-spinner cmn-input-field__spinner"></span>
    </span>
    } @else {
    <svg class="cmnh-input__icon cmnh-input__icon--left cmn-input-field__search-icon" aria-hidden="true"
      viewBox="0 0 24 24">
      <path
        d="M10.5 4a6.5 6.5 0 1 0 3.98 11.64L19.85 21 21 19.85l-5.36-5.37A6.5 6.5 0 0 0 10.5 4Zm0 2a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9Z" />
    </svg>
    }
    }

    <input #inputElement class="cmnh-input cmn-input-field__control" [id]="id" [name]="name" [type]="type"
      [value]="value" [required]="required" [attr.maxlength]="maxlength" [attr.minlength]="minlength"
      [attr.pattern]="pattern" [attr.autocomplete]="autocomplete" [attr.placeholder]="placeholder" [attr.min]="min"
      [attr.inputmode]="inputmode" [disabled]="disabled" [readOnly]="readonly" (input)="handleInput($event)"
      (change)="handleChange($event)" (blur)="handleBlur($event)" [ngClass]="inputClass" />

    @if (hasError) {
    <span class="cmnh-input__icon--error" aria-hidden="true"></span>
    }
  </div>

  @if (hasError) {
  <div class="cmnh-input-error-message cmn-input-field__error">
    @if (control?.errors?.['required']) {
    <div>{{ requiredMessage || ('THIS_FIELD_IS_REQUIRED' | translate) }}</div>
    }

    @if (control?.errors?.['minlength'] && !control?.errors?.['pattern']) {
    <div>{{ minlengthMessage || ('VALIDATION_MIN_LENGTH' | translate) }}</div>
    }

    @if (control?.errors?.['pattern']) {
    <div>{{ patternMessage || ('VALIDATION_FORMAT' | translate) }}</div>
    }

    @if (control?.errors?.['email']) {
    <div>{{ emailMessage || ('VALIDATION_EMAIL' | translate) }}</div>
    }
  </div>
  }

  @if (showMaxlengthReached) {
  <div class="cmnh-input-error-message cmn-input-field__error">
    <div>{{ maxlengthReachedMessage || ('VALIDATION_CHARACTER_LIMIT' | translate) }}</div>
  </div>
  }
</div>